<template>
  <div class="container-panel">
    <HeroFilter @routeHandler="getDataHandler" @searchHandler="getSearchData" />
    <DataGridTable :dataResult="itemResult" :dataDetails="itemFormData" :searchData="searchValue" />
    <CompanyUtilizationModal :isModal="isCurrentActive" @updateModal="isCurrentActive = closeModal" @getDataResult="passData" />
  </div>
</template>
<script>
import HeroFilter from "@/components/common/HeroFilter.vue";
import DataGridTable from "@/components/partials/reports/company-utilization/DataGridTable.vue";
import CompanyUtilizationModal from "@/components/partials/modals/CompanyUtilizationModal.vue";
import { ref } from "vue";
export default {
  components: {
    HeroFilter,
    CompanyUtilizationModal,
    DataGridTable,
  },
  setup() {
    const isCurrentActive = ref(false);
    const searchValue = ref();
    const getDataHandler = (result) => {
      isCurrentActive.value = result;
    };
    const getSearchData = (search) => {
      searchValue.value = search;
    };
    const itemResult = ref([]);
    const itemFormData = ref([]);
    const passData = (data, form) => {
      itemResult.value = data;

      console.log("render1", data);
      itemFormData.value = form;
    };

    return {
      getDataHandler,
      getSearchData,
      passData,
      isCurrentActive,
      itemResult,
      itemFormData,
      searchValue,
    };
  },
};
</script>
